import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isButtonDisabled } from "../../lib/customToast";
import useAuthStore from "../../store/useAuthStore";

// Modal for Join Us selection


const navItems = [
  {
    label: "Blog",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
    ),
    to: "/blogs",
    match: (pathname) => pathname.startsWith("/blogs"),
    type: "link"
  },
  {
    label: "Join Us",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    to: "/joinus",
    match: (pathname) => pathname === "/joinus",
    type: "link"
  },
  {
    label: "Home",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 3.172L2.293 12.88a1 1 0 1 0 1.414 1.415L5 13.001V20a2 2 0 0 0 2 2h3v-6h4v6h3a2 2 0 0 0 2-2v-6l1.293 1.294a1 1 0 0 0 1.414-1.415L12 3.172z" />
      </svg>
    ),
    to: "/",
    match: (pathname) => pathname === "/",
    type: "link"
  },
  {
    label: "Support",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2a8 8 0 0 0-8 8v3a4 4 0 0 0 4 4h1v-6H7V10a5 5 0 0 1 10 0v1h-2v6h1a4 4 0 0 0 4-4v-3a8 8 0 0 0-8-8z" />
      </svg>
    ),
    to: "/support",
    match: (pathname) => pathname.startsWith("/support"),
    type: "link"
  },
  {
    label: "Login",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
      </svg>
    ),
    to: "/login?type=customer",
    match: (pathname) => pathname.startsWith("/login"),
    type: "login"
  }
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, userType, user } = useAuthStore();



  const handleNavClick = (item) => {
    if (item.type === "link") {
      navigate(item.to);
    } else if (item.type === "login") {
      if (token && userType === "customer" && user) {
        navigate("/customer/profile");
      } else {
        navigate("/login?type=customer");
      }
    }
  };



  // Determine active index for sliding
  const activeIndex = navItems.findIndex(item => {
    if (item.type === "login") {
      return location.pathname.startsWith("/login") || location.pathname.startsWith("/customer/profile");
    }
    return item.match(location.pathname);
  });

  const navBgColor = "#1e40af"; // Blue-800 or Blue-600 (#2563EB) ? User asked for "blue". Let's use standard blue.
  // #2563eb is Tailwind blue-600.

  return (
    <>
      <div className="fixed bottom-0 left-0 w-full z-[100] mobile-nav-container safe-area-pb bg-transparent pointer-events-none">
        {/* The Bar */}
        <div
          className="pointer-events-auto relative w-full mx-auto flex items-center justify-between px-0 h-16 shadow-[0_-1px_10px_rgba(0,0,0,0.05)] transition-colors duration-300"
          style={{
            backgroundColor: "#ffffff", // White background
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            borderTop: "1px solid #f3f4f6"
          }}
        >
          {/* Nav Items */}
          {navItems.map((item, index) => {
            const isActive = activeIndex === index;
            const isLogin = item.type === "login";
            let label = item.label;
            if (isLogin && token && userType === "customer" && user && user.name) {
              label = "Profile";
            }

            return (
              <div key={index} className="flex-1 h-full z-20 flex items-center justify-center">
                <button
                  onClick={() => handleNavClick(item)}
                  className="flex flex-col items-center justify-center w-full h-full focus:outline-none"
                >
                  <div
                    className={`transition-all duration-300 flex items-center justify-center rounded-full p-2 ${isActive
                      ? "text-blue-600 bg-blue-50 shadow-[0_0_12px_rgba(37,99,235,0.15)] mb-1" // Active: Blue, Light Blue Bg/Glow
                      : "text-gray-500 mb-1"        // Inactive: Darker Grey
                      }`}
                  >
                    {React.cloneElement(item.icon, { className: "h-6 w-6" })}
                  </div>

                  <span
                    className={`text-[10px] transition-all duration-300 text-black ${isActive ? "font-bold" : "font-medium"
                      }`}
                  >
                    {label}
                  </span>
                </button>
              </div>
            );
          })}
        </div>
      </div>

    </>
  );
};

export default MobileBottomNav;
